import React, { Component } from "react";
import { Box, Text } from "grommet";
import {
  Camera,
  Clipboard,
  Compliance,
  FormCheckmark,
  FormClose,
} from "grommet-icons";

export class TaskItemNameValuePair extends Component {
  getTitle = (taskItem) => {
    switch (taskItem.TaskItemType) {
      case "Form":
        return taskItem.FormItems[0].Title;
      case "Checklist":
        return taskItem.Checklists[0].Title;
      case "Take Photo":
        return taskItem.TakePhotoTaskItems[0].Title;
      default:
        return "";
    }
  };

  getTaskItemComp = (taskItem) => {
    const takePhotoInstances = this.props.takePhotoInstances;

    switch (taskItem.TaskItemType) {
      case "Form":
        //console.log("form", taskItem.FormItems[0]);
        let text = "";

        if (typeof taskItem.FormItems[0] === "object") {
          const formItemId = taskItem.FormItems[0].Id;
          this.props.subTaskInstance.FormItemInstances.forEach(
            (formItemInstance) => {
              // console.log(formItemInstance);
              if (formItemInstance.FormItemId === formItemId) {
                text = formItemInstance.Input;
              }
            }
          );
        }

        return <Text>{text}</Text>;

      case "Checklist":
        console.log("checklist task item", taskItem);
        let completed;
        if (
          typeof taskItem.Checklists === "object" &&
          taskItem.Checklists.length !== 0
        ) {
          const checklistId = taskItem.Checklists[0].Id;
          this.props.subTaskInstance.ChecklistInstances.forEach(
            (checklistInstance) => {
              if (checklistInstance.Checklist.Id === checklistId) {
                completed = checklistInstance.IsComplete;
              }
            }
          );
        }

        let checklistText;
        let checkIcon;
        if (completed) {
          checklistText = "Complete";
          checkIcon = <FormCheckmark></FormCheckmark>;
        } else {
          checklistText = "Incomplete";
          checkIcon = <FormClose></FormClose>;
        }
        return (
          <Box direction="row" alignContent="center">
            {checkIcon}
            <Text>{checklistText}</Text>
          </Box>
        );

      case "Take Photo":
        //console.log("Take photo");
        //console.log(taskItem);
        let url;
        const takePhotoId = taskItem.TakePhotoTaskItems[0].Id;

        for (const takePhotoInstance of takePhotoInstances) {
          if (takePhotoInstance.TakePhotoTaskItemId === takePhotoId) {
            url = takePhotoInstance.URL;
          }
        }

        return (
          <Box
            height="180px"
            width="180px"
            alignContent="center"
            margin={{ horizontal: "medium" }}
          >
            <img height="200px" width="200px" object-fit="cover" src={url} />
          </Box>
        );
    }
  };
  render() {
    const taskItemComp = this.getTaskItemComp(this.props.taskItem);
    const title = this.getTitle(this.props.taskItem);
    return (
      <Box direction="column" margin={"medium"} alignContent={"center"}>
        <Box alignContent="centre" alignSelf="centre">
          <Text>{title}</Text>
        </Box>
        <Box>{taskItemComp}</Box>
      </Box>
    );
  }
}

export default TaskItemNameValuePair;
